export const Instructions = {
	headers: {
		default: {
			product: 'Product Details',
			inbound: 'Inbound Details',
			shipping: 'Shipping Details',
		},
		product: {
			product: 'Product',
			quantity: 'Quantity',
			barcode: 'Barcode',
		},
		inbound: {
			warehouse: 'Warehouse',
			purchaseOrder: 'PO #',
			reference: 'Reference',
			shippingMethod: 'Shipping Method',
			packingMethod: 'Packing Method',
		},
		shipping: {
			shipFrom: 'Ship From',
			tracking: 'Tracking',
			weight: 'Weight',
			dimensions: 'Dimensions',
			arrival: 'Estimated Arrival',
		},
	},
	instructions: {
		default: {
			product:
				'Let us know details about the products you are shipping. You will need to have a product created in your Zorbit Inventory to add it to this Inbound. You can add or remove Products to this Inbound as needed.',
			inbound:
				'Get started with your Inbound creation by letting us know which Zorbit warehouse you’re sending your products and how you’re sending them. You can also include a PO# and Reference to easily identify the Inbound. This Inbound will be saved as a Draft until you submit it, so you’ll be able to leave this form and return to it at any point.',
			shipping:
				'Select a Packing Method in Inbound Details above to fill in Shipping Details. If you are sending products using Zorbit rates, you can use our Shipping Cost Estimator to approximate the shipment cost of your Inbound.',
		},
		product: {
			product:
				'Specify the SKU of the product you’d like to send. Products must be added on the Inventory page before creating an Inbound.',
			quantity:
				'Specify the number of products you are sending with this Inbound. Zorbit will use this number to ensure that all your products have arrived at the warehouse.',
			barcode:
				'Specify the Barcode you’d like to use for your selected Product. If you’ve Inbounded this product before, Zorbit recommends using the same barcode as prior Inbounds.',
		},
		inbound: {
			warehouse:
				'Choose the Zorbit warehouse you’d like to ship your products to. You can only choose one warehouse per inbound. For more information on Zorbit Warehouses, refer to our Warehouse Guide.',
			purchaseOrder:
				'You can choose to include a Purchase Order number to associate with this inbound. This may make it easier for you to associate your shipment with your vendor.',
			reference:
				'You can choose to include a Reference field to associate with this inbound. This may make it easier to identify and keep track of your shipment.',
			shippingMethod:
				'Zorbit can provide you with UPS Shipping Labels if you choose to send your product in boxes. If you’d like to provide your own Shipping Labels, select "Send on my own".',
			packingMethod:
				'Specify how you’ll be sending your products. This will make it easier for the Warehouse to identify and process your inbound shipment. If you choose Pallets, you won’t be able to ship on Zorbit rates.',
		},
		shipping: {
			shipFrom:
				'Select the address your packages will be Shipped From. This will be used as identification if your Inbound cannot be identified.',
			tracking:
				'Provide tracking numbers to allow Zorbit to track your packages. Zorbit can track packages sent with USPS, UPS, FedEx, and DHL eCommerce. You can add, remove, and modify tracking numbers after submitting your Inbound.',
			weight:
				'This is the total weight of the item that you are mailing in pounds and ounces, including packaging, fill, and labels.',
			dimensions:
				'These are the dimensions of your package rounded up to the nearest inch. Dimensions are not required, but can be provided to receive a more accurate rate estimate.',
			shippingArrival:
				'Enter the date you expect this shipment to arrive. If you have a window, please provide the later date.',
		},
	},
};
